import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = {
  key: 0,
  class: "c-stepper"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "c-stepper__progress" }, null, -1 /* HOISTED */)
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "c-stepper__num"
}
const _hoisted_6 = {
  key: 2,
  class: "c-stepper__title"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 3,
  class: "c-stepper__title"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "c-stepper__progress" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "c-stepper__num" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "c-stepper__title" }
const _hoisted_15 = { class: "o-button-group__wrap" }
const _hoisted_16 = {
  key: 0,
  class: "o-button-group -column"
}
const _hoisted_17 = { class: "o-button__ico" }
const _hoisted_18 = { class: "o-button__text -icon-reverse" }
const _hoisted_19 = {
  key: 0,
  class: "o-button__text__elm"
}
const _hoisted_20 = {
  key: 1,
  class: "o-button__text__elm"
}
const _hoisted_21 = { class: "sr-only" }
const _hoisted_22 = {
  href: "/nous-joindre",
  class: "o-button -button-link",
  target: "_self"
}
const _hoisted_23 = { class: "o-button__text" }
const _hoisted_24 = { class: "o-button__text__elm" }
const _hoisted_25 = { class: "sr-only" }
const _hoisted_26 = {
  key: 1,
  class: "c-form-saver"
}
const _hoisted_27 = { class: "o-grid o-grid-12 o-form-styled" }
const _hoisted_28 = { class: "o-grid-12 o-form__item__wrap" }
const _hoisted_29 = { class: "o-title-3" }
const _hoisted_30 = { class: "o-grid-12 o-form__item__wrap" }
const _hoisted_31 = {
  class: "o-label",
  for: "vehicule-vin"
}
const _hoisted_32 = { class: "o-form__item" }
const _hoisted_33 = { class: "o-form__validation" }
const _hoisted_34 = { class: "o-form__validation__required" }
const _hoisted_35 = { class: "o-form__validation__error" }
const _hoisted_36 = { class: "o-grid-12" }
const _hoisted_37 = { class: "o-button-group -column" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "o-button__ico" }
const _hoisted_40 = { class: "o-button__text" }
const _hoisted_41 = { class: "o-button__text__elm" }
const _hoisted_42 = { class: "sr-only" }
const _hoisted_43 = { class: "o-button__text" }
const _hoisted_44 = { class: "o-button__text__elm" }
const _hoisted_45 = { class: "sr-only" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock("div", {
    "data-component-name": _ctx.$options.name
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-sidebar c-sidebar-mobile-overlay", {'is-open' : $props.showSaveModal == true}]),
      "data-lenis-prevent": ""
    }, [
      (!$props.showSaveModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sections, (section, si) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["c-stepper__step", {
                        'is-complete': (si < $props.currentStep || $props.formIsCompleted),
                        'is-current': si === $props.currentStep && !$props.formIsCompleted,
                        'c-stepper__sub__step': section.isSubStep,
                        'is-clickable': si < $props.currentStep,
                    }]),
                key: 'section-'+section.id,
                id: 'section-'+section.id,
                onClick: $event => ($options.goToStep(si))
              }, [
                (!section.isSubStep)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(section.stepIndexLabel), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["c-stepper__sub__num", {'is-clickable': si < $props.currentStep}])
                    }, null, 2 /* CLASS */)),
                (!section.isSubStep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", {
                        innerHTML: section.title
                      }, null, 8 /* PROPS */, _hoisted_7)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("small", {
                        innerHTML: section.title
                      }, null, 8 /* PROPS */, _hoisted_9)
                    ]))
              ], 10 /* CLASS, PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */)),
            _hoisted_10,
            _createElementVNode("div", {
              class: _normalizeClass(["c-stepper__step", {
                        'is-current': $props.formIsCompleted,
                    }])
            }, [
              _createElementVNode("button", _hoisted_11, [
                ($props.formIsCompleted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createVNode(_component_svgIco, { icon: "active" })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createVNode(_component_svgIco, { icon: "email" })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx._t('Complété')), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_15, [
        (!$props.showSaveModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              ($props.allowRecovery === true && $props.result.status !== 'success')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "o-button -button-stroke",
                    target: "_self",
                    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('show-save-modal', true)))
                  }, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_svgIco, {
                        icon: "save",
                        class: "o-ico icon-save"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_18, [
                      (!$props.showSaveModal)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx._t('Pas le temps de finir?')), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createTextVNode(_toDisplayString(_ctx._t('Annuler')) + " ", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx._t('Recommencer plus tard')), 1 /* TEXT */)
                          ]))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx._t('Besoin d’assistance?')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx._t('Redirection vers la page de contact')), 1 /* TEXT */)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      ($props.showSaveModal === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("fieldset", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx._t('Pas le temps de finir?')), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString(_ctx._t('Sauvegardez le formulaire dans son état actuel et continuez plus tard. Un lien vous sera envoyé par courriel.')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx._t('Quelle est votre adresse courriel?')), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.userEmail) = $event)),
                    onInput: _cache[2] || (_cache[2] = (...args) => ($options.validateEmail && $options.validateEmail(...args))),
                    class: "o-input",
                    type: "email",
                    name: "form-save-email",
                    placeholder: "",
                    autocomplete: "email"
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelText, $data.userEmail]
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('save-for-later', {userEmail: $data.userEmail, userPhone: $data.userPhone}))),
                    class: "o-button -stroke",
                    target: "_self",
                    disabled: ($data.emailIsValid === true) ? false : 'disabled'
                  }, [
                    _createElementVNode("span", _hoisted_39, [
                      _createVNode(_component_svgIco, {
                        icon: "save",
                        class: "o-ico icon-save"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx._t('Sauvegarder le formulaire')) + " ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx._t('Sauvegarder le formulaire')), 1 /* TEXT */)
                      ])
                    ])
                  ], 8 /* PROPS */, _hoisted_38),
                  _createElementVNode("button", {
                    class: "o-button -button-link",
                    target: "_self",
                    onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('show-save-modal', false)))
                  }, [
                    _createElementVNode("span", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx._t('Annuler')) + " ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx._t('Annuler la sauvegarde du formulaire')), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}